module.exports = __webpack_public_path__ + "media/images/press_kit/four_seasons_yachts/email/main-white-24889de8a4d70385eb404453f19f3c6f.png";